<form [formGroup]="form">
  <ng-container *ngFor="let setting of formSettings">
    <app-text-field *ngIf="setting.Visible && setting.FieldId != 'MobilePhone'" [settings]="setting" [value]="setting.Value" (valueChange)="modelChange(setting.FieldId, $event)" [form]="form"></app-text-field>
    <app-phone-field *ngIf="setting.Visible && setting.FieldId == 'MobilePhone'" [settings]="setting" [value]="setting.Value" (valueChange)="modelChange(setting.FieldId, $event)" [form]="form"></app-phone-field>
  </ng-container>
</form>

